import { jsx as h } from "react/jsx-runtime";
import { forwardRef as f } from "react";
import k from "@mui/material/Switch";
import y from "styled-components";
import { hexToRgba as o } from "../../theme/utils/styleUtils.js";
import T from "../FormControlLabel/FormControlLabel.js";
const B = {
  root: "switchRoot",
  checked: "switchChecked",
  disabled: "switchDisabled",
  colorPrimary: "switchColorPrimary",
  colorSecondary: "switchColorSecondary",
  switchBase: "switchBase",
  track: "switchTrack",
  thumb: "switchThumb",
  input: "switchInput"
}, l = (i) => {
  let t = "36px";
  return i === "small" && (t = "28px"), i === "large" && (t = "58px"), t;
}, C = (i) => {
  let t = "14px";
  return i === "small" && (t = "10px"), i === "large" && (t = "22px"), t;
}, r = (i) => {
  let t = "20px";
  return i === "small" && (t = "16px"), i === "large" && (t = "32px"), t;
}, v = (i) => {
  let t = "17px";
  return i === "small" && (t = "13px"), i === "large" && (t = "27px"), t;
}, S = y(k).withConfig({
  displayName: "StyledSwitch"
})([
  "&&.switchRoot{color:",
  ";padding:0px;width:",
  ";height:",
  ";overflow:visible;align-items:center;}&& .switchBase{padding:0px;color:transparent;}&&& .switchTrack{width:",
  ";height:",
  ";border-radius:14px;background-color:",
  ";opacity:1;}&& .switchBase.Mui-focusVisible .switchThumb,&& .switchBase.Mui-focusVisible + .switchTrack{box-shadow:0px 4px 20px 0px ",
  ";}&& .switchBase.switchChecked{transform:",
  ";}&& .switchBase.switchChecked + .switchTrack{background-color:",
  ";}&& .switchBase.switchDisabled + .switchTrack{background-color:",
  ";}&& .switchBase.switchChecked.switchDisabled + .switchTrack{background-color:",
  ";}&& .switchBase.switchChecked.switchDisabled + .switchTrack:after{content:'';position:absolute;height:100%;width:100%;top:0px;opacity:0.5;background-color:",
  ";}&& .switchThumb{width:",
  ";height:",
  ";background-color:",
  ";box-shadow:0px 4px 20px 0px ",
  ";}&& .switchBase:hover .switchThumb{box-shadow:0px 4px 20px 0px ",
  ";}&& .switchBase.switchChecked .switchThumb{background-color:",
  ";}&& .switchBase.switchChecked:hover .switchThumb{box-shadow:0px 4px 20px 0px ",
  ";}&& .switchBase.switchDisabled .switchThumb{background-color:",
  ";}&& .switchBase.switchChecked.switchDisabled .switchThumb{background-color:",
  ";}&& .switchBase.switchChecked.switchDisabled:after{content:'';position:absolute;height:100%;width:100%;top:0px;opacity:0.5;background-color:",
  ";border-radius:50%;}"
], ({ theme: i }) => i.text.tertiary, ({ $size: i }) => l(i), ({ $size: i }) => r(i), ({ $size: i }) => l(i), ({ $size: i }) => C(i), ({ theme: i }) => i.isLightTheme ? i.tertiaryBackground : i.colors.darkGrey300, ({ theme: i }) => o(i.primaryFocus, (i.isLightTheme, 0.14)), ({ $size: i }) => `translateX(${v(i)})`, ({ theme: i }) => i.isLightTheme ? i.colors.blue100 : i.colors.blue500, ({ theme: i }) => i.isLightTheme ? i.tertiaryBackground : i.primaryDisabled, ({ theme: i }) => i.isLightTheme ? i.colors.blue100 : i.colors.blue500, ({ theme: i }) => i.primaryBackground, ({ $size: i }) => r(i), ({ $size: i }) => r(i), ({ theme: i }) => i.text.primary, ({ theme: i }) => i.primaryShadow, ({ theme: i }) => i.isLightTheme ? o(i.text.primary, 0.14) : o(i.colors.black, 0.14), ({ theme: i }) => i.primaryFill, ({ theme: i }) => o(i.primaryFill, 0.14), ({ theme: i }) => i.secondaryDisabled, ({ theme: i }) => i.primaryFill, ({ theme: i }) => i.primaryBackground), D = /* @__PURE__ */ f(({ FormControlLabelProps: i = void 0, checkedIcon: t = void 0, classes: d = void 0, className: w = void 0, disabled: a = !1, icon: e = void 0, fullWidth: p = !1, label: c = "", labelPlacement: n = "end", value: u = "off", size: b = "medium", tooltip: m = void 0, ...x }, g) => {
  const s = {};
  return e !== void 0 && (s.icon = e), t !== void 0 && (s.checkedIcon = t), /* @__PURE__ */ h(T, {
    ...i,
    className: w,
    label: c,
    tooltip: m,
    "aria-label": typeof c == "string" ? c : void 0,
    labelPlacement: n,
    labelPlacementOffset: [
      8,
      16,
      8,
      16
    ],
    disabled: a,
    fullWidth: p,
    control: /* @__PURE__ */ h(S, {
      ...x,
      ref: g,
      classes: {
        ...B,
        ...d
      },
      disabled: a,
      color: "default",
      type: "checkbox",
      value: u,
      $size: b,
      ...s
    })
  });
});
D.displayName = "Switch";
export {
  D as default
};
